/**
 * @flow
 * */

/* eslint-disable no-confusing-arrow */

import styled from 'react-emotion'
import Select, { Creatable } from 'react-select'

import Colors from '../../themes/Colors'

import { ErrorText } from '../Input/styledComponents'

export const MainContainer = styled('section')`
  width: 100%;
`

export const CreatableReactSelect = styled(Creatable)`
  border: ${props =>
    props.displayError
      ? `1px solid ${Colors.dullRed}`
      : `1px solid ${Colors.whiteTwo30}`};
`

export const ReactSelect = styled(Select)`
  border: ${props =>
    props.displayError
      ? `1px solid ${Colors.dullRed}`
      : `1px solid ${Colors.whiteTwo30}`};
`

export const ReactSelectError = styled(ErrorText)`
  visibility: ${props => (props.displayError ? 'visible' : 'hidden')};
`



// WEBPACK FOOTER //
// ./src/commons/ReactSelectInput/styledComponents.js